import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LocaleService } from '../services/locale.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LocaleGuard implements CanActivate {
  constructor(private router: Router,
              private localeService: LocaleService,
              private translate: TranslateService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return new Observable<boolean | UrlTree>((observer) => {
      this.localeService.getLocaleForUser().then((locale) => {
        this.translate.use(locale);
        observer.next(true);
        observer.complete();
      });
    });
  }

}
